import { render, staticRenderFns } from "./FavoriteClient.vue?vue&type=template&id=cb2426dc&scoped=true&"
import script from "./FavoriteClient.vue?vue&type=script&lang=js&"
export * from "./FavoriteClient.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteClient.vue?vue&type=style&index=0&id=cb2426dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2426dc",
  null
  
)

export default component.exports